import { useReservationServiceContext } from './state/ReservationServiceContext';
import { FloorPlanSelector } from '@components/floorPlan/FloorPlanSelector';

export const ServiceFloorPlanSelector = () => {
  const {
    floorPlansBySelectedDate,
    selectedFloorPlan,
    setSelectedFloorPlanId,
  } = useReservationServiceContext();

  if (!selectedFloorPlan) return null;

  return (
    <FloorPlanSelector
      floorPlans={floorPlansBySelectedDate}
      selectedFloorPlan={selectedFloorPlan}
      onChange={(floorPlanId) => setSelectedFloorPlanId(floorPlanId!)}
    />
  );
};
